<div class="content" *ngIf="item" style="padding: 5px">
  <form (submit)="save()" #aform #formRef="ngForm" (change)="formChanged = true">
    <div class="alert alert-danger" role="alert" *ngIf="errorMsg">
      <em class="material-icons">warning</em>
      <span class="sr-only">Error:</span> {{ errorMsg }}
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="page-header">
          <div
            class="help-block h4"
            [ngStyle]="{
              cursor: !formRef.form.valid || !item.isValidRecycleType ? 'not-allowed' : 'pointer'
            }"
          >
            Item Entry {{ item.shipped ? "(Shipped)" : "" }}

            <close-button></close-button>
            <button
              type="submit"
              class="btn btn-outline-secondary pull-right"
              [disabled]="!formRef.form.valid || !item.isValidRecycleType"
            >
              <mat-icon title="Save">save</mat-icon>
              <span style="color: salmon; font-weight: bold"> {{ formChanged ? "*" : "" }}</span>
            </button>
            <button
              *ngIf="item.canDelete"
              type="button"
              (click)="remove(item.id)"
              class="btn btn-outline-secondary pull-right"
            >
              <mat-icon>delete</mat-icon>
            </button>
            <button
              title="Make copies of this Item"
              *ngIf="!item.isNew"
              type="button"
              (click)="copyOpen()"
              class="btn btn-outline-secondary pull-right"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
          <hr />
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-2">
            <label for="containerNumber"> Container </label>
            <input
              title="Move to another Container"
              readonly
              required
              type="text"
              autocomplete="off"
              class="form-control"
              [(ngModel)]="item.containerNumber"
              name="containerNumber"
              style="
                background-color: #00aeef;
                cursor: pointer;
                color: #fff;
                text-align: center;
                font-size: large;
              "
              (click)="openMove(item.wasteType)"
            />
          </div>
          <div class="col-md-2">
            <label for="wasteType">Waste Type</label>
            <input
              readonly
              required
              type="text"
              autocomplete="off"
              class="form-control"
              [(ngModel)]="item.wasteType"
              name="wasteType"
            />
          </div>
          <div class="col-md-2">
            <label for="itemNumber"> Item Number </label>
            <input
              readonly
              [required]="!item.isNew"
              type="text"
              autocomplete="off"
              class="form-control"
              [(ngModel)]="item.itemNumber"
              name="itemNumber"
            />
          </div>
          <div class="col-md-2">
            <label for="pickupDate">Pickup Date </label>
            <input
              type="text"
              autocomplete="off"
              required
              class="form-control"
              #datePicker
              [(ngModel)]="item.pickupDate"
              (blur)="item.pickupDate = datePicker.value"
              name="pickupDate"
              bsDatepicker
            />
          </div>
          <div class="col-md-2">
            <label for="enteredBy">Entered By CAI </label>
            <div class="input-group">
              <input
                type="text"
                autocomplete="off"
                readonly
                class="form-control"
                placeholder="CAI"
                [(ngModel)]="item.enteredBy"
                name="enteredBy"
              />
              <span class="input-group-btn">
                <button
                  type="button"
                  style="width: 50px; margin: 0"
                  class="btn btn-outline-secondary form-control"
                  (click)="enteredByPicker.show()"
                >
                  <mat-icon>search</mat-icon>
                </button>
              </span>
            </div>
          </div>
          <div class="col-md-2">
            <label for="enteredByName"> Entered By Name </label>
            <div
              name="ownerenteredByNameName"
              style="font-size: 17px; position: relative; top: 15%"
            >
              {{ item.enteredByName }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-2">
            <label for="owner">Owner CAI </label>
            <div class="input-group">
              <input
                type="text"
                required
                autocomplete="off"
                readonly
                class="form-control"
                placeholder="CAI"
                [(ngModel)]="item.owner"
                name="owner"
              />
              <span class="input-group-btn">
                <button
                  type="button"
                  style="width: 50px; margin: 0"
                  class="btn btn-outline-secondary form-control"
                  (click)="peoplePicker.show()"
                >
                  <mat-icon>search</mat-icon>
                </button>
              </span>
            </div>
          </div>
          <div class="col-md-2">
            <label for="ownerName">Owner Name / Phone </label>
            <div name="ownerName" style="font-size: 17px; position: relative; top: 15%">
              {{ item.ownerName }} - {{ item.phone }}
            </div>
          </div>
          <div class="col-md-2">
            <label for="Organization">Organization</label>
            <div name="Organization" style="font-size: 17px; position: relative; top: 15%">
              {{ item.orgCode }}
            </div>
          </div>
          <div class="col-md-2">
            <label for="bldgNo">Building Number </label>
            <input
              type="text"
              autocomplete="off"
              class="form-control"
              [(ngModel)]="item.bldgNo"
              name="bldgNo"
            />
          </div>

          <div class="col-md-2">
            <label for="labNo">Lab Number </label>
            <input
              type="text"
              autocomplete="off"
              class="form-control"
              [(ngModel)]="item.labNo"
              name="labNo"
            />
          </div>
          <div class="col-md-2">
            <label for="chargeCode">Charge Code</label>
            <input
              type="text"
              autocomplete="off"
              class="form-control"
              [(ngModel)]="item.chargeCode"
              name="chargeCode"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-5">
            <input-filter
              [disabled]="!item.isBulk"
              [data]="wasteStreams"
              [key]="'name'"
              [slice]="10"
              [searchertext]="'Waste Stream'"
              [searchText]="item.streamName"
              (itemSelectedEvent)="setWasteStream($event)"
            ></input-filter>
          </div>
          <div class="col-md-5" *ngIf="item.isLabPack">
            <label for="itemDetail">Item Detail</label>
            <input
              type="text"
              autocomplete="off"
              class="form-control"
              [(ngModel)]="item.itemDetail"
              name="itemDetail"
            />
          </div>
          <div class="col-md-2" *ngIf="item.isLabPack">
            <div>
              <label for="RCRA">RCRA</label>
            </div>
            <input
              style="height: 30px; width: 30px"
              type="checkbox"
              [(ngModel)]="item.labPackRcra"
              name="RCRA"
            />
          </div>
          <div class="col-md-1" *ngIf="item.isRecycle"></div>
          <div class="col-md-6" *ngIf="item.isRecycle">
            <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
              <input
                type="radio"
                class="btn-check"
                value="2"
                (click)="item.setRecycleType(0)"
                id="btnGroup"
                [checked]="item.isLiquidPetrolium"
              />
              <label class="btn btn-outline-secondary" for="btnGroup">Liquid Petroleum</label>

              <input
                type="radio"
                class="btn-check"
                value="1"
                (click)="item.setRecycleType(1)"
                id="btnUser"
                [checked]="item.isSolidPetrolium"
              />
              <label class="btn btn-outline-secondary" for="btnUser">Solid Petroleum</label>

              <input
                type="radio"
                class="btn-check"
                value="0"
                (click)="item.setRecycleType(2)"
                id="btnAny"
                [checked]="item.isEmptyDrum"
              />
              <label class="btn btn-outline-secondary" for="btnAny">Empty Drum</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-11" *ngIf="item.isLabPack">
            <label for="description">Description</label>
            <input
              type="text"
              autocomplete="off"
              class="form-control"
              [(ngModel)]="item.description"
              name="description"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <label for="numberOfItems">Quantity</label>
            <input
              type="number"
              required
              autocomplete="off"
              class="form-control"
              [(ngModel)]="item.numberOfItems"
              name="numberOfItems"
            />
          </div>
          <div class="col-md-2" *ngIf="item.isLabPack">
            <label for="physicalState">Physical State</label>
            <select class="form-select" [(ngModel)]="item.physicalState" name="physicalState">
              <option *ngFor="let k of physicalStateOptions" [value]="k">{{ k }}</option>
            </select>
          </div>
          <div class="col-md-2">
            <label for="volume">Volume</label>
            <div class="input-group">
              <input
                type="number"
                required
                autocomplete="off"
                class="form-control"
                [(ngModel)]="item.volume"
                name="volume"
              />&nbsp;
              <select class="form-select" [(ngModel)]="item.volumeUnits" name="volumeUnits">
                <option></option>
                <option *ngFor="let k of unitsV" [value]="k">{{ k }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-2" *ngIf="!item.isRecycle">
            <label for="weight">Weight</label>
            <div class="input-group">
              <input
                type="number"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="item.weight"
                name="weight"
              />&nbsp;
              <select class="form-select" [(ngModel)]="item.weightUnits" name="weightUnits">
                <option></option>
                <option *ngFor="let k of unitsW" [value]="k">{{ k }}</option>
              </select>
            </div>
          </div>
          <div class="col-md-2" *ngIf="item.isLabPack">
            <label for="itemContainerMaterial">Container Material </label>
            <select
              class="form-select"
              [(ngModel)]="item.itemContainerMaterial"
              name="itemContainerMaterial"
            >
              <option *ngFor="let k of itemContainerMaterials" [value]="k">{{ k }}</option>
            </select>
          </div>
          <div class="col-md-2" *ngIf="item.isLabPack">
            <div>
              <label for="spent">Spent</label>
            </div>
            <input
              style="height: 30px; width: 30px"
              type="checkbox"
              [(ngModel)]="item.spent"
              name="spent"
            />
          </div>
        </div>
        <div class="row" *ngIf="item.isLabPack">
          <div class="col-md-2" *ngIf="item.isLabPack">
            <label for="Organization">&nbsp;</label>
            <div style="font-size: 17px; position: relative; top: 15%; text-align: right">
              RCRA Codes:
            </div>
          </div>
          <div class="col-md-9">
            <label for="wasteCode01"></label>
            <div class="input-group">
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="item.wasteCode01"
                name="wasteCode01"
                maxlength="4"
                (keyup)="wcChanged($event)"
                placeholder="#1"
              />&nbsp;
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="item.wasteCode02"
                name="wasteCode02"
                maxlength="4"
                (keyup)="wcChanged($event)"
                placeholder="#2"
              />&nbsp;
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="item.wasteCode03"
                name="wasteCode03"
                maxlength="4"
                (keyup)="wcChanged($event)"
                placeholder="#3"
              />&nbsp;
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="item.wasteCode04"
                name="wasteCode04"
                maxlength="4"
                (keyup)="wcChanged($event)"
                placeholder="#4"
              />&nbsp;
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="item.wasteCode05"
                name="wasteCode05"
                maxlength="4"
                (keyup)="wcChanged($event)"
                placeholder="#5"
              />&nbsp;
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="item.wasteCode06"
                name="wasteCode06"
                maxlength="4"
                (keyup)="wcChanged($event)"
                placeholder="#6"
              />&nbsp;
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="item.wasteCode07"
                name="wasteCode07"
                maxlength="4"
                (keyup)="wcChanged($event)"
                placeholder="#7"
              />&nbsp;
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="item.wasteCode08"
                name="wasteCode08"
                maxlength="4"
                (keyup)="wcChanged($event)"
                placeholder="#8"
              />&nbsp;
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="item.wasteCode09"
                name="wasteCode09"
                maxlength="4"
                (keyup)="wcChanged($event)"
                placeholder="#9"
              />&nbsp;
              <input
                type="text"
                autocomplete="off"
                class="form-control"
                [(ngModel)]="item.wasteCode10"
                name="wasteCode10"
                maxlength="4"
                (keyup)="wcChanged($event)"
                placeholder="#10"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div title="Move to Container">
    <div
      class="modal my-modal-wrapper fade"
      aria-hidden="true"
      tabindex="-1"
      role="dialog"
      #moveModal
      id="moveModal"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h3>{{ wasteType ? wasteType + " Containers" : "Select a Waste Type" }}</h3>
            <a style="height: 30px" class="circle close" (click)="closeMove()">
              <mat-icon>close</mat-icon>
            </a>
          </div>
          <div class="modal-body">
            <div style="text-align: center" *ngIf="!wasteType">
              <a
                class="btn btn-outline-secondary btn-lg"
                style="width: 20%"
                (click)="selectType('Bulk')"
              >
                Bulk
              </a>
              <a
                class="btn btn-outline-secondary btn-lg"
                style="width: 20%"
                (click)="selectType('LabPack')"
              >
                LabPack
              </a>
              <a
                class="btn btn-outline-secondary btn-lg"
                style="width: 20%"
                (click)="selectType('Recycle')"
              >
                Recycle
              </a>
            </div>
            <div *ngIf="wasteType">
              <div class="input-group">
                <input
                  #filterbox
                  type="text"
                  class="form-control"
                  placeholder="Filter..."
                  name="containerFilter"
                  (keyup)="filterMove(filterbox.value, $event)"
                  (keydown.enter)="filterMove(filterbox.value, $event)"
                />
                <span class="input-group-btn">
                  <button
                    type="button"
                    style="width: 50px; margin: 0"
                    class="btn btn-primary form-control"
                    (click)="filterMove(filterbox.value, $event)"
                  >
                    <mat-icon>search</mat-icon>
                  </button>
                </span>
              </div>
              <br />
              <div *ngIf="openContainers && openContainers.length">
                <div style="overflow-y: auto; height: 580px" class="list-group">
                  <a
                    class="list-group-item"
                    *ngFor="let item of openContainers"
                    (click)="selectMove(item)"
                  >
                    {{ item.containerNumber }}
                    <span style="padding-left: 10px; padding-right: 10px">-</span>
                    {{ item.containerDetail }}
                  </a>
                </div>
                <pager
                  [items]="openContainers.paging"
                  (pageChanged)="pageMove($event)"
                  [options]="{
                    shouldShowFirstPageLink: true,
                    shouldShowNextPageLink: true,
                    shouldShowPreviousPageLink: true,
                    shouldShowLastPageLink: true
                  }"
                >
                </pager>
              </div>
              <div *ngIf="openContainers && !openContainers.length">No Container found</div>
            </div>
            <br />
            <div class="modal-footer">
              <button
                *ngIf="wasteType && item.isNew"
                type="button"
                class="btn btn-outline-secondary"
                (click)="openMove()"
              >
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    title="Copy Items"
    class="modal my-modal-wrapper fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    style="position: absolute"
    #copyModal
    id="copyModal"
  >
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header" style="text-align: center">
          <h3>Copy Item</h3>
          <a class="circle close" (click)="copyClose()">
            <mat-icon>close</mat-icon>
          </a>
        </div>
        <div class="modal-body">
          <label for="copyQty" class="form-label">Quantity: {{ copyQty }}</label>
          <div class="form-group">
            <span>1</span>
            <input
              style="width: 90%"
              type="range"
              id="copyQty"
              name="copyQty"
              min="1"
              max="20"
              step="1"
              class="form-range"
              [(ngModel)]="copyQty"
            />
            <span>20</span>
          </div>
          <br />
          <br />
          <div class="modal-footer">
            <a title="Apply" class="circle circle-add" (click)="copyApply()">
              <mat-icon>copy_all</mat-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <people-picker #peoplePicker (personSelected)="setOwner($event)"></people-picker>
  <people-picker #enteredByPicker (personSelected)="setEnteredBy($event)"></people-picker>
</div>
